import { Product } from "../../../project/models/Product";
import clsx from "clsx";
import "./MowerIcon.scss";
import { GetMowerIconSrc } from "./IconHelper";

export type MowerIconProps = {
  product: Product;
  size?: "small" | "medium" | "large";
};

const MowerIcon = ({ product, size = "small" }: MowerIconProps) => {
  const classes = clsx("mower-icon", { [`mower-icon__${size}`]: !!size });

  return (
    <img
      src={GetMowerIconSrc(product.id)}
      alt={product.name}
      className={classes}
    />
  );
};
export default MowerIcon;
